module.exports = __webpack_public_path__ + "img/LOGRADO.6f0eca8b.png";